import React, {useRef} from "react";
import Printer from "../resources/icon/pirnter-bw.png";
import AiDrawer from "./drawer/simms/AiDrawer";
import {useDispatch, useSelector} from "react-redux";
import {closeKeyAndFlush, openDrawer} from "../redux/slice/opnerSlice";
import {AiLogo} from "../resources/svg/AiLogo";
import {isAdmin, isMobile} from "./commonmethod/CommonMethod";
import {useMobileFixedPageHero} from "../hooks/useMobileFixedPageHero";
import "./layout/pageHeaderHero.css";

function formatIndicatorMeta(indicator) {
    if (!indicator) return null;
    return indicator.replace(/\s*>\s*/g, " · ");
}

function PageHeaderActions({
    headerActions,
    print,
    keys,
    aiAuth,
    dispatch,
    open,
}) {
    return (
        <>
            {headerActions}
            {print ? (
                <button
                    type="button"
                    className="page-header-hero__action-btn flex shrink-0 items-center"
                    onClick={print}
                >
                    <img src={Printer} alt="인쇄" />
                </button>
            ) : null}
            {!isMobile && keys && aiAuth ? (
                <>
                    <button
                        type="button"
                        className="page-header-hero__action-btn page-header-hero__action-btn--ai flex shrink-0 items-center text-[15px]"
                        onClick={() => dispatch(openDrawer({key: "AI"}))}
                    >
                        <AiLogo /> AI 분석/보고서
                    </button>
                    <div
                        className={`drawer-background ${open ? "show" : "none"}`}
                        onClick={() => dispatch(closeKeyAndFlush({key: "AI"}))}
                    />
                    {open && <AiDrawer keys={keys} />}
                </>
            ) : null}
        </>
    );
}

function PageHeader({header, indicator, type, children, print, keys, headerActions}) {
    const heroRef = useRef(null);
    useMobileFixedPageHero(heroRef);
    const dispatch = useDispatch();
    const open = useSelector((state) => state.opener.drawer["AI"] || false);
    const settings = localStorage.getItem("setting");
    const aiManage = JSON.parse(settings)?.find((e) => e.globalsNmAsSnake === "aiManagementControl");
    const user = useSelector((state) => state.auth.user);
    const auth = isAdmin(user);

    const isAiManageEnabled = aiManage?.globalsValue === "true";
    const aiAuth = auth || !isAiManageEnabled;
    const meta = formatIndicatorMeta(indicator);
    const hasActions = headerActions || print || (!isMobile && keys && aiAuth);

    return (
        <header ref={heroRef} className="page-header-hero">
            <div className="page-header-hero__inner">
                <div className="page-header-hero__text">
                    {meta ? <p className="page-header-hero__meta">{meta}</p> : null}
                    <h1 className="page-header-hero__title">{header || ""}</h1>
                    {children ? <div className="page-header-hero__desc">{children}</div> : null}
                </div>
                {hasActions ? (
                    <div className="page-header-hero__actions">
                        <PageHeaderActions
                            headerActions={headerActions}
                            print={print}
                            keys={keys}
                            aiAuth={aiAuth}
                            dispatch={dispatch}
                            open={open}
                        />
                    </div>
                ) : null}
            </div>
            {type ? <div className="page-children px-6 pb-3">{type}</div> : null}
        </header>
    );
}

export {PageHeader};
